// services/studentService.js
const API_BASE_URL = `${process.env.REACT_APP_API_URL}`;

export const studentService = {
  async fetchStudentRecords(searchParams = {}) {
    try {
      // Build query parameters
      const params = new URLSearchParams();

      // Add pagination parameters with defaults
      params.append('page', searchParams.page || 1);
      params.append('limit', searchParams.limit || 10);

      // Add search parameters
      if (searchParams.searchField && searchParams.searchValue) {
        params.append('searchField', searchParams.searchField);
        params.append('searchValue', searchParams.searchValue);
      }

      // Add filter parameters
      if (searchParams.courseType) params.append('courseType', searchParams.courseType);
      if (searchParams.branch) params.append('branch', searchParams.branch); // 🔥 FIXED: Added missing branch parameter
      if (searchParams.courseName) params.append('courseName', searchParams.courseName);
      if (searchParams.batch) params.append('batch', searchParams.batch);
      if (searchParams.learningMode) params.append('learningMode', searchParams.learningMode);
      if (searchParams.progressStatus) params.append('progressStatus', searchParams.progressStatus);

      const queryString = params.toString();
      const url = `${API_BASE_URL}/mentor/students?${queryString}`;

      console.log('Fetching URL:', url); // Debug log

      // 🔐 Get token from localStorage
      const token = localStorage.getItem('token');

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log('API Response:', result); // Debug log

      // Handle the response structure based on your backend API
      if (result.success && result.data) {
        return {
          data: result.data,
          pagination: result.pagination || {
            currentPage: 1,
            totalPages: 1,
            totalRecords: result.data.length,
            recordsPerPage: result.data.length
          },
          totalRecords: result.pagination?.totalRecords || result.data.length
        };
      } else {
        console.warn('Unexpected API response structure:', result);
        return {
          data: [],
          pagination: {
            currentPage: 1,
            totalPages: 1,
            totalRecords: 0,
            recordsPerPage: 10
          },
          totalRecords: 0
        };
      }
    } catch (error) {
      console.error('Error fetching student records:', error);
      throw new Error('Failed to fetch student records. Please try again later.');
    }
  },

  // Update a student record
async updateStudentRecord(studentData) {
  try {
    // Debug: Log the student data being sent
    console.log('Student data being sent:', studentData);
    console.log('ProgressStatus value:', studentData.ProgressStatus); // Changed to capital P
    console.log('ProgressStatus type:', typeof studentData.ProgressStatus); // Changed to capital P

    // First, update the student record
    const response = await fetch(`${API_BASE_URL}/students-record/${studentData.id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(studentData),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const updatedRecord = await response.json();

    // Check for ProgressStatus with correct casing
    if (studentData.ProgressStatus !== undefined && studentData.ProgressStatus !== null && studentData.ProgressStatus !== '') {
      console.log('Updating registration with ProgressStatus:', studentData.ProgressStatus);
      
      try {
        const token = localStorage.getItem('token');

        const registrationResponse = await fetch(`${process.env.REACT_APP_API_URL}/registrations/${studentData.studentId}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            studentProgressStatus: studentData.ProgressStatus, // Changed to capital P
          }),
        });

        if (!registrationResponse.ok) {
          console.warn(`Failed to update registration record: ${registrationResponse.status}`);
        } else {
          console.log('Registration record updated successfully');
        }
      } catch (registrationError) {
        console.error('Error updating registration record:', registrationError);
      }
    } else {
      console.log('ProgressStatus not found or undefined, skipping registration update');
    }

    return updatedRecord;
  } catch (error) {
    console.error('Error updating student record:', error);
    throw new Error('Failed to update record. Please try again.');
  }
}
};